import "./Footer.css";

function Footer() {
    return (
        <footer className="text-center text-muted">
            <div>Copyright &copy; 2022. Coded by Raymond Fajiculay</div>
        </footer>
    );
}

export default Footer;
